import {type ReportDistributionBlock} from '@/api/reporting';

// Past the categorical palette's eight colours two parts would share one, so the smallest fold into
// "Other" as the dashboard's risk breakdown does.
export const SLICE_LIMIT = 8;
const OTHER = 'Other';

export type Slice = {key: string; name: string; value: number; color: string};

// Parts are keyed by position, not by category: a category is free text ("Suicide & Self Harm"),
// and the chart container publishes each key as a `--color-<key>` custom property.
export function distributionSlices(block: ReportDistributionBlock): Slice[] {
  const sized = block.rows
    .map((row) => ({
      name: String(row[block.category.field] ?? 'Unknown'),
      value: row[block.value.field]
    }))
    .filter(
      (row): row is {name: string; value: number} => typeof row.value === 'number' && row.value > 0
    )
    .toSorted((a, b) => b.value - a.value);

  const kept = sized.length > SLICE_LIMIT ? sized.slice(0, SLICE_LIMIT - 1) : sized;
  const rest = sized.slice(kept.length);
  if (rest.length > 0) {
    kept.push({name: OTHER, value: rest.reduce((sum, row) => sum + row.value, 0)});
  }

  return kept.map((slice, i) => ({
    ...slice,
    key: `s${i}`,
    color: `var(--chart-cat-${i + 1})`
  }));
}
